import { useState, useEffect } from 'react';
import { useAuth } from './useAuth.jsx';
import { orgApi } from '../api/org.js';

/**
 * Who the current user is, for filling in an email template's sign-off
 * ("Best regards, {{senderName}} / {{chapterName}}") with real data instead
 * of bracket placeholders. Shared by every "Generate email draft" / "Send
 * email" feature (CommsTab, SpeakerDetailPage, EventFormPage).
 *
 * @returns {{name: string|undefined, email: string|undefined, chapterName: string|null}}
 */
export function useSender() {
  const { user } = useAuth();
  const [chapterName, setChapterName] = useState(null);

  useEffect(() => {
    orgApi.getMine()
      .then((org) => setChapterName(org?.name ?? null))
      .catch(() => {}); // non-critical — templates fall back to a placeholder
  }, []);

  return {
    name: user?.user_metadata?.full_name,
    email: user?.email,
    chapterName,
  };
}
